module.exports = __webpack_public_path__ + "img/20190813160756QQ截图20190813042110.85a5c6e7.png";